import React from 'react';
import { Form, Spinner } from 'react-bootstrap';

import { useFetchMondayBoards } from '../../../../services/supportAdmin';

const MondayBoardSelector = ({ value, onChange, placeholder = 'Select a Monday board...', disabled = false }) => {
  const { isLoading, data, error } = useFetchMondayBoards();

  if (isLoading) {
    return (
      <div className="d-flex align-items-center">
        <Spinner animation="border" size="sm" className="me-2" />
        <span className="text-muted">Loading boards...</span>
      </div>
    );
  }

  if (error) {
    return (
      <Form.Control
        as="select"
        disabled
        className="text-danger"
      >
        <option>Error loading boards</option>
      </Form.Control>
    );
  }

  const boards = (data?.boards || []).filter(
    // Filter out subitem boards
    (board) => !board.name.toLowerCase().startsWith('subitems of')
  );

  const handleChange = (e) => {
    const boardId = e.target.value;
    const selectedBoard = boards.find((b) => b.id === boardId);
    // Pass both boardId and boardName to onChange (boardName is optional second arg)
    onChange(boardId, selectedBoard?.name || '');
  };

  return (
    <Form.Select
      value={value || ''}
      onChange={handleChange}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {boards.map((board) => (
        <option key={board.id} value={board.id}>
          {board.name}
        </option>
      ))}
    </Form.Select>
  );
};

export default MondayBoardSelector;
